import type { IngestionSourceSummary, ListIngestionSourcesResult } from '@jums-dashboard/shared';
import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/app/auth';
import { callFunction } from '@/lib/callableClient';

const STALE_TIME_MS = 30_000;

export default function useIngestionSources(homeId: string | undefined) {
  const { status } = useAuth();
  const enabled = status === 'authorized' && !!homeId;

  return useQuery<IngestionSourceSummary[]>({
    queryKey: ['homeAutomation', 'ingestionSources', homeId ?? null],
    queryFn: async () => {
      const res = await callFunction<{ homeId: string }, ListIngestionSourcesResult>('listIngestionSourcesCallable', { homeId: homeId! });
      return res.keys;
    },
    enabled,
    staleTime: STALE_TIME_MS,
  });
}

export const ingestionSourcesQueryKey = (homeId: string | undefined) => ['homeAutomation', 'ingestionSources', homeId ?? null] as const;
